import React from 'react';
import cn from 'classnames';
import styles from '../QuickShopModal.module.scss';
import ScriptLoader from '../util/ScriptLoader';
import processHtml from '../util/ScriptProcessor';
const ArketTemplate = ({ QSProduct, articleId, }) => {
    const allScripts = processHtml(QSProduct);
    // Adjust styling inline for the incoming HTML since we can't apply a className to those elemnts
    const OForm = QSProduct.querySelector('[data-component="OForm"]');
    if (OForm instanceof HTMLElement) {
        OForm.style.width = '100%';
    }
    const content = QSProduct.querySelector('.content');
    if (content instanceof HTMLElement) {
        content.style.width = '100%';
    }
    const image = QSProduct.querySelector('.o-quick-buy .m-product-image');
    if (image instanceof HTMLElement) {
        image.style.margin = '0';
        const imgElement = image.querySelector('img');
        if (imgElement !== null) {
            imgElement.style.width = '90%';
        }
    }
    const placeholderWrapper = QSProduct.querySelector('.o-quick-buy .m-product-image .placeholder-wrapper');
    if (placeholderWrapper instanceof HTMLElement) {
        placeholderWrapper.style.paddingBottom = 'calc(100% * 4/3';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ScriptLoader, { scripts: allScripts, articleId: articleId, importantScriptIndex: 1, batchIdentifier: "scriptAbove" }),
        React.createElement("div", { className: cn(styles.QSProduct, 'o-quick-buy', styles.arket), "data-variant-number-reached": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-variant-number-reached'), "data-order-lines-reached": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-order-lines-reached'), "data-code-quick-buy": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-code-quick-buy'), "data-component": "OQuickBuy", dangerouslySetInnerHTML: {
                __html: QSProduct.querySelector('.o-quick-buy').innerHTML,
            } })));
};
export default ArketTemplate;
//# sourceMappingURL=ArketTemplate.js.map